import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Cookie, X } from 'lucide-react'
import './CookieBanner.css'

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem('nexcore_cookie_consent')
    if (!consent) setTimeout(() => setVisible(true), 1200)
  }, [])

  const accept = () => {
    localStorage.setItem('nexcore_cookie_consent', 'accepted')
    setVisible(false)
  }

  const decline = () => {
    localStorage.setItem('nexcore_cookie_consent', 'declined')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-banner__icon"><Cookie size={22} /></div>
      <div className="cookie-banner__text">
        <strong>We use cookies</strong>
        <p>We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. Read our <Link to="/cookies">Cookie Policy</Link> and <Link to="/privacy">Privacy Policy</Link>.</p>
      </div>
      <div className="cookie-banner__actions">
        <button className="btn-outline" onClick={decline}>Decline</button>
        <button className="btn-primary" onClick={accept}>Accept All</button>
      </div>
      <button className="cookie-banner__close" onClick={decline} aria-label="Close"><X size={16} /></button>
    </div>
  )
}
